/** Tableau's country actions allow additive marks and clear their filter on deselection. */
export function selectCountryMark(selected: string[], country: string, additive = false): string[] {
  if (additive) {
    return selected.includes(country) ? selected.filter((value) => value !== country) : [...selected, country];
  }
  return selected.length === 1 && selected[0] === country ? [] : [country];
}

/** Keep the same country scope for both source datasets, including the existing null member. */
export function countryMatchesSelection(selected: string[], country: string | null): boolean {
  return !selected.length || selected.includes(country ?? 'Unknown');
}

/** A territory's sovereign alias must not steal the sovereign country's own geometry. */
export function countryGeoNames(
  features: Array<{ properties: { name: string; aliases: string[] } }>,
): Map<string, string> {
  const names = new Map(features.map(({ properties }) => [properties.name, properties.name]));
  for (const { properties } of features) {
    for (const alias of properties.aliases) {
      if (!names.has(alias)) names.set(alias, properties.name);
    }
  }
  return names;
}
